// Mirrors Finkit.Notifications DTOs/enums.
// NotificationDto : EntityDto<Guid> + Title/Message/PopupMessage/Data/Category/Behavior/CreationTime/IsRead.
export interface NotificationDto {
  id: string;
  title: string;
  message: string;
  popupMessage?: string | null;
  data?: string | null;
  category: NotificationCategory;
  behavior: NotificationBehavior;
  creationTime: string;
  isRead: boolean;
}

// Finkit.Enums.CommonServices.Notifications.NotificationCategory (int enum, declaration order).
export enum NotificationCategory {
  DealAlert = 0,
  Recalculation = 1,
  NopThreshold = 2,
  LpMarginThreshold = 3,
  VolumeMatching = 4,
  TerminalRequest = 5,
  TerminalInvalidPassword = 6,
  SymbolAutoAdded = 7,
  RtbeBreach = 8,
  RtbeInfo = 9,
  FeedMonitoring = 10,
  ProviderTransactionsProcessed = 11,
  PendingRequest = 12,
}

// Finkit.Enums.CommonServices.Notifications.NotificationBehavior ([Flags]).
export enum NotificationBehavior {
  None = 0,
  Popup = 1,
  Save = 2,
  Email = 3,
  HighPriority = 4,
  Sound = 5,
  Persist = 6,
}

// Finkit.Notifications.NotificationInputDto : PaginatedInputDto.
export interface NotificationInputDto {
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  isRead?: boolean | null;
  category?: NotificationCategory | null;
}

export interface PaginatedNotifications {
  items: NotificationDto[];
  totalCount: number;
}
